// This Components is just to define the animated components routes
import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
// Routes
import PrivateRoute from "./PrivateRoute";
import Booking from "../pages/Booking";
import NotFound from "../pages/404";
import Home from "../pages/Home";
import Login from "../pages/Login";
import Register from "../pages/Register";
import About from "../pages/About";
import Contact from "../pages/Contact";
import Blog from "../pages/Blog";
import Insurrances from "../pages/Insurrances";
import Insurrance from "../pages/Insurrance";
import OnlineServicesPage from "../pages/OnlineServices/OnlineServices";
import Invoices from "../pages/OnlineServices/Invoices";
import ClaimReport from "../pages/OnlineServices/ClaimReport";

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />}></Route>
        <Route path="/login" element={<Login />}></Route>
        <Route path="/insurrances" element={<Insurrances />}></Route>
        <Route path="/insurrances/:slug" element={<Insurrance />} />
        <Route path="/insurrances/:slug/book" element={<PrivateRoute />}>
          <Route path="/insurrances/:slug/book/" element={<Booking />} />
        </Route>
        {/* <Route path="/insurr" */}
        <Route path="/about" element={<About />}></Route>
        <Route path="/contact" element={<Contact />}></Route>
        <Route path="/blog" element={<Blog />}></Route>
        <Route path="/online-services" element={<OnlineServicesPage />}></Route>
        <Route path="/online-services/invoices" element={<Invoices />} />
        <Route path="/online-services/claim-report" element={<ClaimReport />} />
        {/* <Route path="/login" element={<Login />}></Route> */}
        <Route path="/register" element={<Register />}></Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AnimatePresence>
  );
}

export default AnimatedRoutes;
